import {

    useState

} from "react";

import CRMLayout
from "../components/layout/CRMLayout";

import useLeads
from "../hooks/useLeads";
import LeadDrawer from "../components/lead/LeadDrawer";
import LeadGrid from "../components/lead/LeadGrid";
import LeadToolbar from "../components/lead/LeadToolbar";
import AddLeadDialog from "../components/dialogs/AddLeadDialog";
import Sidebar from "../components/layout/Sidebar";
import BuilderLayout from "../../../common/layouts/BuilderLayout";
import Header from "../components/layout/Header";
import Drawer from "../../../common/drawer/Drawer";

export default function LeadsPage(){

    const {

    loading,

    leads,

    filters,pagination,

    setFilters,

    refresh,

    createLead

}=useLeads();

const [

    selectedLeadId,

    setSelectedLeadId

]=useState(null);

const [

    showAddDialog,

    setShowAddDialog

]=useState(false);
async function handleCreateLead(payload){

    try{

        const response=
            await createLead(payload);

        setShowAddDialog(false);

        await refresh();

       
        if(response?.id){

            setSelectedLeadId(

                response?.id

            );

        }

    }

    catch(error){

        console.error(error);

    }

}
    return(

     <div style={{marginTop:"0px"}}>
<BuilderLayout

    title="Priyara CRM"
    actionLabel="Add New Lead"

    onAction={() =>{ setShowAddDialog(true)}


    }
   width={300}
    sidebar={
  <Sidebar/>

           
    
   

    }

    toolbar={

       <div></div>

    }

    footer={

      <div></div>

    }

>
  <div style={{fontSize:"28px",fontWeight:999}}>  Leads</div>

    {/* <Header/> */}
    <LeadToolbar

        filters={filters}

        onFiltersChange={setFilters}

        onRefresh={refresh}

        onCreateLead={()=>

            setShowAddDialog(true)

        }

    />
   <LeadGrid

    loading={loading}

    leads={leads}
 pagination={pagination}

    onPageChange={page=>

        setFilters(

            previous=>({

                ...previous,

                page

            })

        )

    }
    onSelectLead={setSelectedLeadId}

    onCreateLead={()=>

        setShowAddDialog(true)

    }

/>
    

</BuilderLayout>


<Drawer

    open={!!selectedLeadId}

    width={650}

    title="Lead Details"

    subtitle={

      ""

    }

    onClose={(reload)=>

           {
            
            setSelectedLeadId(null)
            if(reload=="reload"){refresh()}}}

>
<LeadDrawer

        open={!!selectedLeadId}

        leadId={selectedLeadId}

        onClose={(reload)=>

           {
            
            setSelectedLeadId(null)
            if(reload=="reload"){refresh()}} 

        }

    />
    

</Drawer>
    <AddLeadDialog

        open={showAddDialog}

        onClose={()=>

            setShowAddDialog(false)

        }

          onSave={handleCreateLead}

    />
</div>

    );

}